import { api } from '../../../services/api'

export async function resendEmailConfirmation(auth0_id: string): Promise<void> {
  await api.post(`/api/me/identities/${auth0_id}/resend_email_confirmation`)
}
